<div class="invite-users">
  <div class="container"
       style="display: flex; flex-direction: row; gap: 10px; justify-content: center;">

    <mat-card>
      <mat-card-title>
        <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Invite new survey user</h2>
      </mat-card-title>
      <mat-card-content>
        <form class="example-form">
        </form>
        <form class="example-form">
          <mat-form-field class="example-full-width">
            <mat-label>Email addressses</mat-label>
            <textarea matInput  name="emailAddresses" [(ngModel)]="model.emailAddresses"
                      required></textarea>
            <mat-hint>separate multiple email addresses with a comma</mat-hint>
          </mat-form-field>
        </form>
      </mat-card-content>
      <mat-card-actions>
        <div class="form-group">
          <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onInvite()">Register
          </button>
          <img *ngIf="loading"
               src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
          <button mat-raised-button style="border-radius: 6px;" [routerLink]="['/users']">Cancel</button>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
